// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

export const S = {
  Container: styled.div.attrs<{ className: string }>({ className: 'exit-done' })`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.71);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    &.enter,
    &.exit-active,
    &.exit-done,
    &.enter-active,
    &.enter-done,
    &.exit {
      transition-duration: 0.3s;
      transition-property: opacity, visibility;
    }

    &.enter,
    &.exit-active,
    &.exit-done {
      opacity: 0;
      visibility: hidden;
    }

    &.exit,
    &.enter-active,
    &.enter-done {
      visibility: visible;
      opacity: 1;
    }
  `,
  Box: styled.div<{ hasChildren: boolean }>`
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 12px;
    background: ${({ hasChildren }) => (hasChildren ? 'white' : 'transparent')};
  `
};
